var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixleselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 19.4999C16.3662 19.4999 19.5002 16.3659 19.5002 12.4999C19.5002 8.63388 16.3662 5.49988 12.5002 5.49988C8.63425 5.49988 5.50024 8.63388 5.50024 12.4999C5.50024 16.3659 8.63425 19.4999 12.5002 19.4999Z",
    stroke: "#292D32",
    strokeWidth: 1.29655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 15.3001C14.0459 15.3001 15.2995 14.0465 15.2995 12.5001C15.2995 10.9537 14.0459 9.70007 12.4995 9.70007C10.9531 9.70007 9.69946 10.9537 9.69946 12.5001C9.69946 14.0465 10.9531 15.3001 12.4995 15.3001Z",
    stroke: "#292D32",
    strokeWidth: 1.29655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 5.03354V3.16687",
    stroke: "#292D32",
    strokeWidth: 1.29655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0339 12.4999H3.16724",
    stroke: "#292D32",
    strokeWidth: 1.29655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 19.9667V21.8333",
    stroke: "#292D32",
    strokeWidth: 1.29655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.967 12.4999H21.8337",
    stroke: "#292D32",
    strokeWidth: 1.29655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixleselect);
export default __webpack_public_path__ + "static/media/Pixleselect.7661bc7c971e5ed2e54b3be01fc17361.svg";
export { ForwardRef as ReactComponent };